// filepath: apps/web/src/features/admin/userRoles/UserRolesRoute.tsx
//
// FR-UI-ADM-5 AC-11 — route shell for the user-role assignment
// admin editor.
//
// URL: /admin/users
//
// The route enforces the staging-only gate at the SPA layer
// (defense-in-depth; the server rejects production writes with
// HTTP 403 staging_only on PUT/DELETE/POST).

import React from "react";
import { StagingOnlyError } from "@/features/admin/StagingOnlyError";
import { UserRolesPage } from "./UserRolesPage";

interface UserRolesRouteProps {
  /** Resolved environment kind from /api/tenant-config. */
  environmentKind: string;
}

export function UserRolesRoute({
  environmentKind,
}: UserRolesRouteProps): React.ReactElement {
  if (environmentKind !== "staging") {
    return <StagingOnlyError environmentKind={environmentKind} />;
  }
  return <UserRolesPage environmentKind={environmentKind} />;
}
